import React from "react";
import {Box, Stack} from "@mui/material";
import {DeviceHistoryEntry, DeviceHistoryEntryType} from "../../../../app/api/model/deviceHistory";
import {hasJsonStructure} from "../helpers";
import {EetsDeviceHistoryEntry, EetsDeviceHistoryType} from "../../../../app/api/model/eetsDevice";
import DeviceHistoryInformationContent, {
    SUPPORTED_TYPES as DEVICE_SUPPORTED_TYPES,
} from "./DeviceHistoryInformationContent";
import EetsDeviceHistoryInformationContent, {
    SUPPORTED_TYPES as EETS_SUPPORTED_TYPES,
} from "./EetsDeviceHistoryInformationContent";
import JsonViewButton from "./JsonVIewButton";
import TextViewButton from "./TextViewButton";

export interface HistoryInformationCellProps {
    entry: DeviceHistoryEntry | EetsDeviceHistoryEntry;
    onOpenJsonView?: (jsonObj: object) => void;
    onOpenTextView?: (text: string) => void;
}

function HistoryInformationCell({entry, onOpenJsonView, onOpenTextView}: HistoryInformationCellProps) {
    let content: React.ReactNode = entry.information;
    if (DEVICE_SUPPORTED_TYPES.includes(entry.type as DeviceHistoryEntryType)) {
        content = <DeviceHistoryInformationContent entry={entry as DeviceHistoryEntry} />;
    } else if (EETS_SUPPORTED_TYPES.includes(entry.type as EetsDeviceHistoryType)) {
        content = <EetsDeviceHistoryInformationContent entry={entry as EetsDeviceHistoryEntry} />;
    }

    const json = hasJsonStructure(entry.information);

    return (
        <Stack direction="row" justifyContent="space-between" sx={{fontSize: 12}}>
            <Box
                maxWidth="sm"
                sx={{overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", margin: "auto 0"}}
            >
                {content}
            </Box>
            {onOpenJsonView && json && <JsonViewButton entry={entry} onOpenJsonView={onOpenJsonView} />}
            {onOpenTextView && !json && <TextViewButton entry={entry} onOpenTextView={onOpenTextView} />}
        </Stack>
    );
}

export default HistoryInformationCell;
